import { translate } from '@jsverse/transloco';
export enum Theme {
    light = 'light',
    dark = 'dark',
}

export class ThemeHelper {
    static getThemeLocale(theme: Theme) {
        switch (theme) {
            case Theme.light:
                return translate('THEME.LIGHT');
            case Theme.dark:
                return translate('THEME.DARK');
            default:
                return '';
        }
    }
}
